export default {
  data () {
    return {
      isInViewport: false
    }
  },
  mounted () {
    const el = this.$el
    el.onIntersect = () => {
      if (this.isInViewport) {
        return
      }
      el.addEventListener('mouseenter', this.onMouseEnter)
      el.addEventListener('mouseleave', this.onMouseLeave)
      this.isInViewport = true
      this.onViewportEnter()
    }
    el.onOutersect = () => {
      if (!this.isInViewport) {
        return
      }
      el.removeEventListener('mouseenter', this.onMouseEnter)
      el.removeEventListener('mouseleave', this.onMouseLeave)
      this.isInViewport = false
      this.onViewportLeave()
    }
  },
  methods: {
    observeElement () {
      if (this.$el) {
        this.$window.iObserver.observe(this.$el)
      }
    },
    unobserveElement () {
        this.$window.iObserver.unobserve(this.$el)
    },
    onViewportLeave () {
      if (this.$el) {
        this.unobserveElement()
      }
    }
  }
}
